module.exports = __webpack_public_path__ + "static/Grupo 62-343d2a4c723262229e82178ebabb6bda.svg";